import { AfterContentInit, ContentChild, Directive, inject, TemplateRef } from "@angular/core";

import { TableComponent } from "../table/table.component";

@Directive({
	selector: "ic-table-actions",
	standalone: false,
})
export class TableActionsDirective implements AfterContentInit {
	private readonly parent = inject(TableComponent);

	@ContentChild("headerTmpl", { static: false }) headerTemplate: TemplateRef<any>;
	@ContentChild("cellTmpl", { static: false }) cellTemplate: TemplateRef<any>;

	ngAfterContentInit() {
		const template = {
			...(this.headerTemplate && { header: this.headerTemplate }),
			...(this.cellTemplate && { cell: this.cellTemplate }),
		};

		this.parent.registerAs("actionsTemplate", template);
	}
}
